import Heading from '@kurtosys/ksys-app-components/dist/components/base/Heading';
import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent(Heading, 'mfaSetup', ['heading']);